import styled from 'styled-components';

const ff = (theme) => `font-family: ${theme.fonts.secondaryFontFamily}; letter-spacing: 0.45px`;

const H1 = styled.h1(
  ({ theme }) => `
    font-size:20px;
    ${ff(theme)}
`
);

const H2 = styled.h2(
  ({ theme }) => `
    font-size:16px;
    ${ff(theme)}
`
);

export default {
  H1,
  H2,
};
